// src/cn/pages/SmallTalk/SmallTalkPageCN.jsx
import { useState } from "react";
import { SmallTalkAI } from "../../../lib/smalltalkApi";

function getLang() {
  return (typeof document !== "undefined" && document.documentElement?.lang) || "ko";
}

export default function SmallTalkPageCN() {
  const lang = getLang();

  const [record, setRecord] = useState("");
  const [busy, setBusy] = useState(false);
  const [resultHtml, setResultHtml] = useState('');

  function emptyMessage() {
    return lang === "zh-CN"
      ? '<p class="text-red-500 text-center">请先输入患者记录。</p>'
      : '<p class="text-red-500 text-center">환자 기록을 먼저 입력해주세요.</p>';
  }

  function genErrorText() {
    return lang === "zh-CN" ? "生成结果时发生问题。请重试。" : "결과를 생성하는 데 문제가 발생했습니다. 다시 시도해주세요.";
  }

  function sysErrorHtml() {
    return lang === "zh-CN"
      ? '<p class="text-red-500 text-center">抱歉。发生了错误。请稍后再试。</p>'
      : '<p class="text-red-500 text-center">죄송합니다. 오류가 발생했습니다. 잠시 후 다시 시도해주세요.</p>';
  }

async function handleGenerate() {
    const value = record.trim();
    if (!value) {
      setResultHtml(wrapReport(emptyMessage()));
      return;
    }

    setBusy(true);
    setResultHtml(""); // clear

    try {
      const { text } = await SmallTalkAI.generate({ record: value });
      const raw = String(text || "");

      // ✅ 불릿/번호형 목록까지 잡기: -, •, *, 1.
      const lines = raw.split("\n").map((l) => l.trim()).filter(Boolean);

      const topicLines = lines.filter((l) => /^[-•*]\s+/.test(l) || /^\d+\.\s+/.test(l));

      if (topicLines.length > 0) {
        const listHtml = topicLines
          .map((line) => {
            const onlyText = line.replace(/^([-•*]|\d+\.)\s+/, "").trim();
            return `
              <div class="report-markdown">
                <span>${escapeHtml(onlyText)}</span>
              </div>
            `;
          })
          .join("");

        setResultHtml(wrapReport(listHtml));
      } else {
        // ✅ 목록이 아니어도 래퍼는 항상 유지
        setResultHtml(wrapReport(`<p>${escapeHtml(raw).replace(/\n/g, "<br>")}</p>`));
      }
    } catch (e) {
      console.error(e);
      setResultHtml(wrapReport(sysErrorHtml()));
    } finally {
      setBusy(false);
    }
  }

  // ✅ 래퍼를 "항상" 씌우기
  function wrapReport(innerHtml) {
    return `<div class="report-body"><div class="report-body-area">${innerHtml}</div></div>`;
  }

  // 간단한 HTML escape (결과 안전 표시용)
  function escapeHtml(s) {
    return String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  return (
    <section className="smallTalk">
      <div id="content_title">
        <h2>闲聊话题生成器</h2>
        <p>请输入患者的最后一次就诊记录，找到温暖自然的对话话题吧！</p>
      </div>

      <div className="content">
        {/* 입력 섹션 */}
        <div className="">
          <div className="">
            <p>患者就诊记录</p>
            <textarea
              rows={4}
              className="textarea"
              placeholder="例如：成功减重1.5kg，饮食控制做得很好。下周计划去济州岛旅行。"
              value={record}
              onChange={(e) => setRecord(e.target.value)}
            />
          </div>
        </div>

        {/* 생성 버튼 */}
        <div className="" style={{ alignItems: "center" }}>
          <button id="generate-button" className="submitbtn" onClick={handleGenerate}>
            生成对话话题
          </button>
        </div>

        {/* 결과 섹션 */}
        <div className="">
          <div id="result-container">
            {busy ? "在氨纶生产中" : <div className="report" dangerouslySetInnerHTML={{ __html: resultHtml }} />}
          </div>
        </div>
      </div>
    </section>
  );
}
